export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.config.errorHandler = (error, context) => {
    if (import.meta.client) {
      //  NOTE: SSRでは、ログに個人情報が出ないように、出力しない
      /* eslint-disable-next-line no-console */
      console.info(error)
    }
  }

  nuxtApp.hook('page:finish', async () => {
    const errorStore = useErrorStore()
    if (!errorStore.hasCurrentError()) {
      //  NOTE: このタイミングで、エラー情報をクリアしないと、
      //  画面表示時に、チラチキが発生する。
      await errorStore.clearDapError()
    }
  })
})